import React from "react";
import { useTranslation } from "react-i18next";
import { Building2, MapPin } from "lucide-react";
import { textStyles } from "@/lib/textStyles";

interface HospitalCardProps {
  hospitalName?: string;
  city?: string;
  state?: string;
  country?: string;
}

export const HospitalCard: React.FC<HospitalCardProps> = ({
  hospitalName,
  city,
  state,
  country,
}) => {
  const { t } = useTranslation("profile");
  const location = [city, state, country].filter(Boolean).join(", ");

  if (!hospitalName && !location) return null;

  return (
    <div className="border rounded-xl p-4 space-y-3">
      <h2 style={textStyles.heading3}>{t("institution.title")}</h2>

      {hospitalName && (
        <div className="flex items-center gap-2">
          <Building2 className="w-4 h-4 text-gray-400 shrink-0" />
          <p className="text-gray-900" style={textStyles.body}>
            {hospitalName}
          </p>
        </div>
      )}

      {location && (
        <div
          className="flex items-center gap-2 text-gray-500"
          style={textStyles.body}
        >
          <MapPin className="w-4 h-4 text-gray-400 shrink-0" />
          <span>{location}</span>
        </div>
      )}
    </div>
  );
};
